import { APP_NAME } from "../constants";
import { motion } from "framer-motion";

const Services = ({ services }) => {
  return (
    <section id="services">
      <div className="container mt-5 mb-5">
        <div className="row py-5">
          <div className="col-12">
            <motion.p
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: "easeInOut" }}
              viewport={{ once: true }}
              className="texts"
            >
              At {APP_NAME} we offer a comprehensive range of dog training
              services tailored to meet the needs of both pet owners and
              professional organizations. From basic obedience training to
              specialized programs for police and service dogs, we provide
              expert guidance and support to help dogs and their owners reach
              their full potential.
            </motion.p>
          </div>
          <div className="col-12">
            <motion.p
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: "easeInOut" }}
              viewport={{ once: true }}
              className="texts"
            >
              Our services include obedience training, behavior modification,
              off-leash training, agility training, police dog training, service
              dog training, protection dog training, boarding and daycare,
              grooming, and consulting. Whether you're looking to improve your
              dog's behavior, train a working dog, or simply find a reliable
              place for your pet while you're away, we have the expertise and
              resources to help you achieve your goals.
            </motion.p>
          </div>
          <div className="col-12">
            <motion.p
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: "easeInOut" }}
              viewport={{ once: true }}
              className="texts"
            >
              With commitments ranging from one-time, recurring or contract, we
              are committed to meet all the needs and requirement of our client.
              We also have professional veterinary doctors that ensures that
              your dogs are in perfect shape and in good health.
            </motion.p>
          </div>
        </div>
        <div className="row g-3 mt-3 pb-5">
          {services.map((item, index) => (
            <div className="col-12 mb-3" key={index}>
              <div className="d-flex flex-lg-row flex-column gap-3">
                <div className="col-lg-5 col-md-6">
                  <div className="image-container">
                    <img
                      src={item.image}
                      alt={`Service - ${index}`}
                      className="img-fluid rounded service-image"
                      loading="lazy"
                    />
                  </div>
                </div>
                <div className="col-lg-7 col-md-6">
                  <div className="card h-100">
                    <div className="card-body d-flex flex-column p-4">
                      <h4 className="card-title text-custom-red mb-4 fw-bold">
                        {item.title}
                      </h4>
                      <motion.p
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, ease: "easeInOut" }}
                        viewport={{ once: true }}
                        className="flex-grow-1 texts"
                      >
                        {item.description}
                      </motion.p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
